import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import {
  API_KEY_ATTRIBUTE,
  ENTRY_ATTRIBUTE,
  MODEL_ATTRIBUTE,
} from '../constants';

@Injectable()
export class BuilderContentService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public appendScript() {
    const scripElement = this.renderer.createElement('script');
    this.renderer.setAttribute(
      scripElement,
      'src',
      'https://cdn.builder.io/js/webcomponents',
    );
    this.renderer.appendChild(this.document.head, scripElement);
  }

  public getBuilderElement(apiKey: string, entry: string) {
    const builderContentElement: HTMLElement =
      this.renderer.createElement('builder-component');
    this.renderer.setAttribute(builderContentElement, ENTRY_ATTRIBUTE, entry);
    this.renderer.setAttribute(builderContentElement, MODEL_ATTRIBUTE, 'page');
    this.renderer.setAttribute(
      builderContentElement,
      API_KEY_ATTRIBUTE,
      apiKey,
    );
    return builderContentElement;
  }
}
